import { getUserInfo, setCache, getCache, getUserFontList } from '@/apis/app';
import { SET_STATE } from './helper';
import { Sentry } from '@/utils/sentry';
import { createMappingTable } from '@/utils';

export default {
  namespaced: true,
  state: {
    userInfo: {},
    customFontList: [],
  },
  getters: {
    customFontMap(state) {
      return createMappingTable(state.customFontList, 'fontName');
    },
  },
  mutations: {
    SET_STATE,
  },
  actions: {
    getUserInfo: async ({ commit, state }) => {
      // 缓存
      if (state.userInfo?.id) {
        commit('SET_STATE', { userInfo: state.userInfo });
        return state.userInfo;
      }
      try {
        const res = await getUserInfo();
        const { email, id, name } = res.user;
        Sentry.setTag('userid', id);
        Sentry.setUser({ username: name, email, id });
        commit('SET_STATE', { userInfo: res.user });
        return res;
      } catch (err) {
        commit('SET_STATE', { userInfo: null });
        return null;
      }
    },
    setCache({ state }, payload) {
      if (state.userInfo?.id || import.meta.env.DEV) {
        setCache(payload);
      } else {
        console.log('未登录，不记录');
      }
    },
    getCache({ state }, payload) {
      if (state.userInfo?.id || import.meta.env.DEV) {
        return getCache(payload);
      } else {
        console.log('未登录，不记录');
        return null;
      }
    },

    async getFontList({ commit }, payload = {}) {
      const params = {};
      const { Token } = payload;
      if (Token) {
        Object.assign(params, { token: Token });
      }
      const list = await getUserFontList(params);
      commit('SET_STATE', { customFontList: list });
    },
  },
};
